var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "24px",
    viewBox: "0 0 20 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon / Base / Location") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "expermentation-v02",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.0-additional-details",
    transform: "translate(-31.000000, -431.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(16.000000, 408.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Color",
    transform: "translate(9.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,4 C21.5228475,4 26,8.2980664 26,13.6 C26,17.1346224 22.6666667,21.9346224 16,28 C9.33333333,21.9346224 6,17.1346224 6,13.6 C6,8.2980664 10.4771525,4 16,4 Z M16,7.5 C13.2385763,7.5 11,9.73857625 11,12.5 C11,15.2614237 13.2385763,17.5 16,17.5 C18.7614237,17.5 21,15.2614237 21,12.5 C21,9.73857625 18.7614237,7.5 16,7.5 Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.48b4f41fc80fddb906a29783ec4adcb0.svg";
export { ForwardRef as ReactComponent };